import { envelope, phone, linkedin } from "svelte-awesome/icons";
import { diamond, code, desktop } from "svelte-awesome/icons";

export const jobs = [
  {
    id: 1,
    company: "Sabre, Inc.",
    location: "Southlake, Texas",
    title: "User Experience Design Principal",
    dates: "2015 - 2020",
    accomplishments: [
      "As part of a small specialized team of senior-level designers and developers, I collaborated with Sabre’s Research & Labs team to conceptualize and flesh out new product ideas for future revenue opportunities. I was involved in the rapid mockup wireframes of prototypes and demos based on typically very general business requirements, as well as the programming of the applications.",
      "2019 - 2020: Programmed a fully functional HTML, JavaScript, and CSS web application prototype for a conceptual commissions contract creator product using the Svelte JavaScript compiler.",
      "2018: Programmed a single-page web application demo for a personalized flight recommendation concept for the Travel Services Exchange conference. Framework used was VueJS.",
      "For that same 2018 conference, I programmed a web application informational micro site using VueJS  to showcase the Research & Labs team’s product concepts for that year.",
      "In 2018, I performed product design assessments for eight products with which the Sabre UX teams were engaged. I compiled a report for each team with recommendations to ensure consistency across the portfolio, as well recommendations for best practices for UX Design, usability, and accessibility.",
      "Served as a hands-on consultant within the UX Design teams for several products to provide guidance, process recommendations, and general senior-level perspective.",
    ],
  },
  {
    id: 2,
    company: "Sabre, Inc.",
    location: "Southlake, Texas",
    title: "Senior User Experience Designer",
    dates: "2012 - 2015",
    accomplishments: [
      "Served as Lead UX Designer for a large business intelligence web application. Responsible for translating business requirements into wireframe mockups, and following through to a full user interface, including usability testing of fully functional HTML prototypes.",
      "Created a fully functional tablet prototype for a proposed airline check-in application using AngularJS (v1).",
      "Developed a fully functional proof-of-concept prototype for a prospective customer using the Sencha framework.",
      "Team lead for initiative to create style guide for use by all Sabre Airline Solutions teams for mobile (handheld) device applications.",
      "Created the HTML and CSS for a web-based Kiosk application.",
      "Rebranding Sabre’s white-label web airline booking engine and check-in applications for over a dozen customers.",
    ],
  },
  {
    id: 3,
    company: "IBM/Sterling Commerce, Inc.",
    location: "Irving, Texas",
    title: "User Experience Designer",
    dates: "2002 - 2011",
    accomplishments: [
      "UX lead on a secure file transfer web application project, where I translated business requirements into documented themes and user stories, established high-level application flow, information architecture, and user interface design for the product",
      "Designed from scratch up through five major releases the user interface for Sterling Control Center, a managed file transfer monitoring desktop and web application utilized by large financial organizations and government agencies.",
    ],
  },
  {
    id: 4,
    company: "i2 Technologies, Inc.",
    location: "Irving, Texas",
    title: "User Interface Design Team Lead",
    dates: "2000 - 2002",
    accomplishments: [
      "Managed and supervised user interface design team for i2’s Supply Chain Collaboration, a product with over $10 million in annual revenues, through two major software releases.",
      "Oversaw team's activities in conducting Contextual Design interviews with customers to collect requirements and use them to introduce new product design. These activities included collecting and prioritizing requirements, and defining product functionality, process workflows, and individual interface designs.",
      "Coordinated and led team’s efforts in maintaining compliance with i2’s design and usability standards for the Supply Chain Management product.",
      "Served on committee responsible for the creation of interactive design elements and usability standards for use by all i2 applications.",
      "Analyzed and reengineered workflows for i2 sourcing, commerce, and marketplace applications to improve product usability and customer experience, leading to increased licensed revenues and client satisfaction.",
    ],
  },
  {
    id: 5,
    company: "UsWeb/CKS, MarchFirst",
    location: "Dallas, Texas",
    title: "Customer Experience Designer",
    dates: "1998 - 2000",
    accomplishments: [
      "Translated brand strategy and business requirements to design and enhance the customer experience and information architecture for customers such as the US Postal Service, JCPenney, AIMCO, and WeServe Homes.",
      "Produced site maps, process flows, page schematics, HTML prototypes and functional specifications documentation.",
      "Established information architecture methodologies and processes that were implemented company-wide as proper business practices.",
      "Business Analyst activities included collection, analysis and documentation of business requirements.",
    ],
  },
  {
    id: 6,
    company: "Specialized Medical Management, Inc.",
    location: "Fort Worth, Texas",
    title: "Analyst/Programmer",
    dates: "1993 - 1998",
    accomplishments: [
      "Participated in development of company business plan and marketing plan.",
      "Responsible for documentation of budget for purposes of tracking and analysis.",
      "Built company Internet and Intranet web sites; developed web applications serving the physician community.",
    ],
  },
];

export const contactItems = [
  {
    text: "LinkedIn",
    label: "LI Profile",
    url: "https://www.linkedin.com/in/guy-briggs-aa82a2/",
    icon: linkedin,
  },
  {
    text: "Email",
    label: "gdbriggs4@gmail.com",
    url: "mailto:gdbriggs4@gmail.com",
    icon: envelope,
  },
  {
    text: "Phone",
    label: "(214) 695-0843",
    url: "tel:1-214-695-0843",
    icon: phone,
  },
];

export const skills = [
  {
    category: "Design",
    items: [
      { name: "Balsamiq", rating: 80 },
      { name: "Sketch", rating: 75 },
      { name: "Invision", rating: 75 },
      { name: "Information Architecture", rating: 75 },
      { name: "Wireframing", rating: 85 },
      { name: "Workflow Diagramming", rating: 75 },
      { name: "Adobe Suite", rating: 75 },
    ],
    icon: diamond,
  },
  {
    category: "Development",
    items: [
      { name: "HTML", rating: 95 },
      { name: "CSS", rating: 95 },
      { name: "JavaScript", rating: 80 },
      { name: "Svelte", rating: 95 },
      { name: "VueJS", rating: 80 },
      { name: "React", rating: 75 },
      { name: "Angular", rating: 70 },
      { name: "JSON", rating: 85 },
      { name: "Git", rating: 75 },
    ],
    icon: code,
  },
  {
    category: "Other",
    items: [
      { name: "Business Analysis", rating: 70 },
      { name: "Project Management", rating: 60 },
      { name: "Accessibility", rating: 75 },
      { name: "The French language", rating: 50 },
    ],
    icon: desktop,
  },
];
